module.exports = __webpack_public_path__ + "img/heart.de1b27d9.png";